<div id="basicsAccordion">
  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['11'] = !show['11']"
        >
          {{ 'What are integrations?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['11']">
      <div class="card-body">
        {{
          'Integrations are modules and plugins that allow you to connect to e-commerce platforms like Shopify, OpenCart, WooCommerce, Magento and Shopamine and to payment gateways like Braintree and Stripe. It also allows users to create custom integrations directly with our API.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['1'] = !show['1']"
        >
          {{ "What are Apollo's basic system requirements?" | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['1']">
      <div class="card-body">
        {{
          'Apollo is an online app which means there are no installations needed to start using the app. All you need is internet and a modern web browser such as Google Chrome, Mozilla Firefox, Apple Safari or Microsoft Edge. We also recommend keeping your browser up-to-date.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['2'] = !show['2']"
        >
          {{ 'How do I pay for a subscription plan?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['2']">
      <div class="card-body">
        {{
          'Immediately after ordering, you will receive an estimate with all the payment details for the plan. In the case of online payment (PayPal / Credit card) you will receive an invoice for the paid amount to your email account.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['3'] = !show['3']"
        >
          {{ 'When can I start using the Free plan?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['3']">
      <div class="card-body">
        {{
          'The free plan can be used immediately after registration.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['4'] = !show['4']"
        >
          {{
            'pricing-faq.when-can-i-start-using-the-simple-or-advanced-plan.question'
              | translate
          }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['4']">
      <div class="card-body">
        {{
          'Simple and Unlimited plans can be used immediately after the order.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['5'] = !show['5']"
        >
          {{ 'Are there any costs connected to using the app?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['5']">
      <div class="card-body">
        {{ 'The Free plan can be used indefinitely.' | translate }}
        {{
          'The Simple and Unlimited plans are registered either for one month or one year, with automatic renewal charged to users paying by credit card or PayPal until canceled in the app. Users who paid by bank transfer will receive an email with the estimate for renewal. Once payment is received, the account will be extended. There are no additional costs.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['10'] = !show['10']"
        >
          {{
            'Are integrations and fiscalization modules included in Simple and Unlimited pakages?'
              | translate
          }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['10']">
      <div class="card-body">
        {{
          "No. Each additional integration and fiscalization module activated is chargeable at an additional 50% of your plan's cost."
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['6'] = !show['6']"
        >
          {{
            'Do I need to enter my credit card data to register?' | translate
          }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['6']">
      <div class="card-body">
        {{
          'No. Apollo does not require a credit card until the purchase of a paid plan. A Simple and/or an Unlimited Plan may be paid for by credit card via Paypal or bank transfer.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['7'] = !show['7']"
        >
          {{ 'Is my data safe?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['7']">
      <div class="card-body">
        {{
          'We use industry standard security measures for physical and electronic protection of data. All communications with our systems are secured by SSL security exceeding industry standards, ranked A+ by Qualys SSL Labs.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['8'] = !show['8']"
        >
          {{ 'Is Apollo a reliable full-time solution?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['8']">
      <div class="card-body">
        {{ 'pricing-faq.is-apollo-reliable.answer' | translate }}
      </div>
    </div>
  </div>
  <!-- End Card -->

  <!-- Card -->
  <div class="card mb-3">
    <div class="card-header card-collapse">
      <h5 class="mb-0">
        <button
          class="btn btn-link btn-block d-flex justify-content-between card-btn p-3"
          (click)="show['9'] = !show['9']"
        >
          {{ 'More questions?' | translate }}
        </button>
      </h5>
    </div>
    <div id="basicsCollapseOne" class="collapse" [class.show]="show['9']">
      <div class="card-body">
        {{
          'Team Apollo is always available in case of questions or issues with app usage. You can contact with us directly in app or by email to support.'
            | translate
        }}
      </div>
    </div>
  </div>
  <!-- End Card -->
</div>
